module.exports = __webpack_public_path__ + "img/ce6a250.png";